export const columns = [
  {
    title: "Código",
    dataIndex: "codigo",
    width: "20%",
  },
  {
    title: "Pokémon",
    dataIndex: "nombrePokemon",
    width: "20%",
  },
  {
    title: "Estado",
    dataIndex: "estado",
    width: "10%",
  },
  {
    title: "Fecha Creación",
    dataIndex: "fechaCreacion",
    width: "20%",
  },
];
export const formatData = (data) => {
  return {
    idLogro: data.id,
    logr_nombre: data.nombre,
    logr_descripcion: data.descripcion,
    logr_dificultad: data.dificultad,
    logr_imagen: data.imagen,
    tilo_id: data.idTipoLogro,
  };
};

export const camposFormulario = (pokemon = []) => {
  return {
    title: "Códigos Pókemon",
    campos: [
      {
        name: "pokemones",
        label: "Pókemon",
        type: "multiple",
        opciones: pokemon,
        rules: [
          {
            required: true,
            message: "Debe seleccionar al menos un Pokémon",
          },
        ],
      },
      {
        name: "cantidad",
        label: "Cantidad",
        type: "number",
        max: 10,
        min: 1,
        rules: [
          {
            required: true,
            message: "La cantidad es obligatoria",
          },
        ],
      },
    ],
  };
};
export const camposFilter = (estados = []) => ({
  title: "Códigos Pokémon",
  campos: [
    {
      name: "mostrarTodos",
      placeholder: "Estado",
      type: "autocomplete",
      opciones: estados,
    },
  ],
});
